import { toast } from 'react-toastify';
import { clientFetch } from '@/utils/service';
import { isFunction } from '@/utils/helpers';
import {
  FETCH_USER,
  ADD_GIFT_CONSULTATION_USER,
  ADD_GIFT_NUTRITION_CONSULTATION_USER,
  UPDATE_USER,
  DELETE_CONSULTATION_USER,
  DELETE_NUTRITION_CONSULTATION_USER,
} from './actionsTypes';

export const fetchUserApi = async (id) => clientFetch(`/admin/users/${id}`);

export const fetchUser = (id) => {
  return {
    type: FETCH_USER,
    payload: fetchUserApi(id),
  };
};

export const addConsultationsForUser = async ({
  data,
  dispatch,
  onSuccess,
  onError,
}) => {
  return clientFetch('/admin/consultations/add', {
    method: 'POST',
    body: JSON.stringify(data),
  })
    .then((res) => {
      dispatch({
        type: `${ADD_GIFT_CONSULTATION_USER}_FULFILLED`,
        payload: res,
      });
      isFunction(onSuccess) && onSuccess(res);
    })
    .catch((err) => {
      dispatch({
        type: `${ADD_GIFT_CONSULTATION_USER}_REJECTED`,
        payload: err,
      });
      isFunction(onError) && onError(err);
    });
};

export const addNutritionConsultationsForUser = async ({
  data,
  dispatch,
  onSuccess,
  onError,
}) => {
  return clientFetch('/admin/nutrition-consultations/add', {
    method: 'POST',
    body: JSON.stringify(data),
  })
    .then((res) => {
      dispatch({
        type: `${ADD_GIFT_NUTRITION_CONSULTATION_USER}_FULFILLED`,
        payload: res,
      });
      isFunction(onSuccess) && onSuccess(res);
    })
    .catch((err) => {
      dispatch({
        type: `${ADD_GIFT_NUTRITION_CONSULTATION_USER}_REJECTED`,
        payload: err,
      });
      isFunction(onError) && onError(err);
    });
};

export const deleteConsultationsForUser = (id, { onSuccess, t, specialistType = 'psychologist' }) => {
  const isNutritionist = specialistType === 'nutritionist';
  const path = isNutritionist ? 'nutrition-consultations' : 'consultations';
  return {
    type: isNutritionist ? DELETE_NUTRITION_CONSULTATION_USER : DELETE_CONSULTATION_USER,
    payload: clientFetch(`/admin/${path}/${id}`, {
      method: 'DELETE',
    })
      .then((res) => {
        toast.success(t('user.consultations.delete_success'));
        isFunction(onSuccess) && onSuccess(res);
        return { id };
      })
      .catch(() => {
        toast.error(t('user.consultations.delete_error'));
      }),
  };
};

export const activateUser = async ({ id, dispatch, onSuccess, onError }) => {
  const type = UPDATE_USER;

  return clientFetch(`/admin/users/${id}/activate`, {
    method: 'POST',
  })
    .then((res) => {
      dispatch({
        type: `${type}_FULFILLED`,
        payload: res,
      });
      isFunction(onSuccess) && onSuccess(res);
    })
    .catch((err) => {
      dispatch({
        type: `${type}_REJECTED`,
        payload: err,
      });
      isFunction(onError) && onError(err);
    });
};

export const changeUserPassword = async ({
  id,
  data = {},
  dispatch,
  onSuccess,
  onError,
}) => {
  const formData = {
    ...data,
  };
  const type = UPDATE_USER;

  return clientFetch(`/admin/users/${id}/change-password`, {
    method: 'POST',
    body: JSON.stringify(formData),
  })
    .then((res) => {
      dispatch({
        type: `${type}_FULFILLED`,
        payload: res,
      });
      isFunction(onSuccess) && onSuccess(res);
    })
    .catch((err) => {
      dispatch({
        type: `${type}_REJECTED`,
        payload: err,
      });
      isFunction(onError) && onError(err);
    });
};
